<template>
  <!-- 通报批评-扣分列表 -->
  <div class="deduct_list">
    <div class="head pb-12">
      <div class="head_left flex flex-col">
        <div> {{ title }}</div>
        <div class="flex-row  text-12 text-[#999999] font-400">
          <span> {{ areaName }}</span>
          <span class="ml-8">{{ quarterName }}</span>
        </div>
      </div>
      <div class="head_right">
        <p v-if="accidentScore != 0" class="score">{{ accidentScore }}</p>
        <p v-else class="noScore">未扣分</p>
        <p class="percent">{{ surplusScore }}/{{ allScore }}</p>
      </div>
    </div>
    <div class="save_list mt-24">
      <div class="list">
        <!--<div class="list_top">
           <div class="total">
            共
            <span>{{allList}}</span> 条扣分记录
          </div> 
          <btnauth custype="apply" :year="year" :quarter="quarter">
            <van-button
              v-if=" addAuth === 'OPERATION01'"
              @click="addSituation"
              class="add_btn"
              size="small"
              type="primary"
              color="#36B374"
            ><span class="plus">+</span><span>新增</span></van-button>
          </btnauth>  -->
      </div>
      <!-- <div v-if="accidentList.length > 0" class="record_list">
          <div class="record_item">
            <div>
              <div class="record_title">
                <span>受到通报批评</span>
              </div>
              <div class="deduct_item" v-for="item in accidentList" :key="item.id">
                <div class="reason deal_cont">
                  <div class="left_cont">
                    <span>受处理内容：</span>
                    <span class="deal_c">{{ item.punishDesc }}</span>
                  </div>
                  <div class="cont">
                    <span v-if="item.audited == 0" class="status">未审核</span>
                    <span v-if="item.audited == 1" class="deduct_score">-{{ item.deduction / 100 }}分</span>
                  </div>
                </div>
                <div class="reason">
                  <span>受处理时间：</span>
                  <span>{{ item.punishTime.split('-')[0] + '年' + item.punishTime.split('-')[1] + '月' + item.punishTime.split('-')[2] + '日' }}</span>
                </div>
                <div class="see_more" @click="goDetail(item)">
                  <span>查看详情</span>
                  <img src="@/assets/appraise/ic_jt_ck_l@2x.png" alt />
                </div>
              </div>
            </div>
          </div>
        </div> -->
      <div class="record_list">
        <div class="record_item">
          <div class="flex flex-row ">
            <!-- left -->
            <div class="flex-1 flex flex-col ">
              <div class="text-16 text-[#333333] font-bold">受到上级问责、约谈、通报批评情况</div>
              <div class="mt-16 text-12 text-[#666666] font-400">
                <div v-if="meetList.length > 0">发生扣分情况： {{ meetList.length }}起</div>
                <span v-else> 未发生扣分情况</span>
              </div>
              <div class="see_more" @click="goDetail('E2')">
                <span>查看详情</span>
                <img src="@/assets/appraise/ic_jt_ck_l@2x.png" alt />
              </div>
            </div>
            <!-- right -->
            <div class=" flex flex-col items-center">
              <div class="text-[#FF4D4D] font-bold text-12 leading-12">-{{ totalDeduction(meetList) }}分</div>
              <div class="text-[#FF4D4D] font-bold text-12 leading-12"
                v-if="totalDeduction(meetList) >= 2 ">
                已达扣分上限
              </div>
            </div>
          </div>
          <!-- 下面的不要了，要下个页面才能用了 -->
          <!-- <div>
            <div class="record_title">
              <span>受到上级问责、约谈、通报批评情况</span>
            </div>
            <div class="deduct_item" v-for="item in meetList" :key="item.id">
              <div class="reason deal_cont">
                <div class="left_cont">
                  <span>受处理内容：</span>
                  <span class="deal_c">{{ item.punishDesc }}</span>
                </div>
                <div class="cont">
                  <span v-if="item.audited == 0" class="status">未审核</span>
                  <span v-if="item.audited == 1" class="deduct_score">-{{ item.deduction / 100 }}分</span>
                </div>
              </div>
              <div class="reason">
                <span>受处理时间：</span>
                <span>{{ item.punishTime.split('-')[0] + '年' + item.punishTime.split('-')[1] + '月' +
                  item.punishTime.split('-')[2] + '日' }}</span>
              </div>
              <div class="see_more" @click="goDetail(item)">
                <span>查看详情</span>
                <img src="@/assets/appraise/ic_jt_ck_l@2x.png" alt />
              </div>
            </div>
          </div> -->
        </div>
      </div>
      <div  class="record_list">
        <div class="record_item">
          <div class="flex flex-row ">
            <!-- left -->
            <div class="flex-1 flex flex-col ">
              <div class="text-16 text-[#333333] font-bold">涉旅企业警告、整改、取消等级</div>
              <div class="mt-16 text-12 text-[#666666] font-400">
                <div v-if="abarbeitungList.length > 0">发生扣分情况： {{ abarbeitungList.length }}起</div>
                <span v-else> 未发生扣分情况</span>
              </div>
              <div class="see_more" @click="goDetail('E3')">
                <span>查看详情</span>
                <img src="@/assets/appraise/ic_jt_ck_l@2x.png" alt />
              </div>
            </div>
            <!-- right -->
            <div class=" flex flex-col items-center">
              <div class="text-[#FF4D4D] font-bold text-12 leading-12">-{{ totalDeduction(abarbeitungList) }}分</div>
              <div class="text-[#FF4D4D] font-bold text-12 leading-12"
                v-if="totalDeduction(abarbeitungList) >= 5 ">
                已达扣分上限
              </div>
            </div>
          </div>
          <!-- <div>
            <div class="record_title">
              <span>涉旅企业警告、整改、取消等级</span>
            </div>
            <div class="deduct_item" v-for="item in abarbeitungList" :key="item.id">
              <div class="reason deal_cont">
                <div class="left_cont">
                  <span>受处理内容：</span>
                  <span class="deal_c">{{ item.punishDesc }}</span>
                </div>
                <div class="cont">
                  <span v-if="item.audited == 0" class="status">未审核</span>
                  <span v-if="item.audited == 1" class="deduct_score">-{{ item.deduction / 100 }}分</span>
                </div>
              </div>
              <div class="reason">
                <span>受处理时间：</span>
                <span>{{ item.punishTime.split('-')[0] + '年' + item.punishTime.split('-')[1] + '月' +
                  item.punishTime.split('-')[2] + '日' }}</span>
              </div>
              <div class="see_more" @click="goDetail(item)">
                <span>查看详情</span>
                <img src="@/assets/appraise/ic_jt_ck_l@2x.png" alt />
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <!-- <div v-if="!showList" class="no_data">
        <div class="no_data_img">
          <img src="@/assets/appraise/ic_wuxingxi@2x.png" alt />
        </div>
        <div class="no_data_tip">
          <p>该州市未发生</p>
          <p>受到上级通报批评、约谈、问责等处理情况</p>
        </div>
        <btnauth custype="apply" :year="year" :quarter="quarter">
          <div class="add_btn_box" v-if=" addAuth === 'OPERATION01'">
            <van-button
              @click="addSituation"
              class="add_btns"
              size="small"
              type="primary"
              color="#36B374"
            ><span class="plus">+</span><span>新增</span></van-button>
          </div>
        </btnauth>
      </div>
    </div> -->
  </div>
</template>

<script>
import api from "@/service/modules/appraiseNew.js";
import commonAPI from "@/utils/common";
import btnauth from "../appraiseNew/components/btnauth";
import { mapMutations, mapState } from "vuex";
export default {
  components: {
    btnauth,
  },
  data() {
    return {
      title: "",
      dataList: [1],
      showList: false,
      accidentList: [], // 收到通报批评列表
      meetList: [], // 受到约谈问责列表
      abarbeitungList: [], // 整改列表
      accidentScore: 0, // 扣分总数
      surplusScore: 10, // 剩余分数
      allScore: 0, // 总分
      // 三个子项 权限
      accidentListAuth: "",
      meetListAuth: "",
      abarbeitungListAuth: "",
      // 新增 删除 编辑 审核权限
      userAuthoirese: "",
      addAuth: '',
      addBtn: "",
      updateAuth: "",
      deleteAuth: "",
      year: this.$route.query.year,
      quarter: this.$route.query.quarter,
      quarterName: this.$route.query.quarterName,
      areaName: this.$route.query.areaName,
      allList: 0,
      isAlllist: []
    };
  },
  created() {
    this.initData();
    const childAuth = commonAPI.getAuthorityList("ASSESS_SCORE");
    const notifyobj = commonAPI.getChileAuthList(childAuth, "MENU05"); //受到通报批评、约谈、问责等情况
    // 先 判断大项。再判断 小项的 按钮权限
    console.log("-----受到通报批评大项的值:", notifyobj);

    if (notifyobj && notifyobj.children) {
      const childList = notifyobj.children;
      this.accidentListAuth = "";
      this.meetListAuth = "";
      this.abarbeitungListAuth = "";
      for (let i = 0; i < childList.length; i++) {
        if (childList[i].assessType === "E1") {
          this.accidentListAuth = "E1";
        }
        if (childList[i].assessType === "E2") {
          this.meetListAuth = "E2";
        }
        if (childList[i].assessType === "E3") {
          this.abarbeitungListAuth = "E3";
        }
      }
      let temValue = "";
      if (this.accidentListAuth === "E1") {
        temValue = "MENU0501";
      } else if (this.meetListAuth === "E2") {
        temValue = "MENU0502";
      } else if (this.abarbeitungListAuth === "E3") {
        temValue = "MENU0503";
      }
      const childObj = commonAPI.getChildAuthListToChild(notifyobj, temValue);
      if (childObj && childObj.length > 0) {
        this.userAuthoirese = "";
        this.addBtn = "";
        this.updateAuth = "";
        this.deleteAuth = "";
        for (let i = 0; i < childObj.length; i++) {
          if (childObj[i].value === "OPERATION06") {
            //审核权限
            this.userAuthoirese = "OPERATION06";
          }
          if (childObj[i].value === "OPERATION01") {
            // 新增
            this.addAuth = "OPERATION01";
          }
          if (childObj[i].value === "OPERATION02") {
            //编辑
            this.updateAuth = "OPERATION02";
          }
          if (childObj[i].value === "OPERATION03") {
            //删除
            this.deleteAuth = "OPERATION03";
          }
        }
      }
    }
  },
  computed: {
    /** 列表中是否有已审核的项，有已审核的项就显示扣分，不管扣分是否为 0 **/
    isShowDeduction() {
      return this.isAlllist.map((e) => e.audited).includes(1);
    },
    
  },
  methods: {
    ...mapMutations('appraise', ['setECategoryList']),
    initData() {
      this.title = "受到上级通报批评、约谈、问责等处理情况";
      this.queryList();
    },
    // 查询列表
    queryList() {
      const { quarter, area, year } = this.$route.query;
      let params = {
        quarter,
        area,
        year,
      };
      api.findLeaderNoticeMeet(params).then((res) => {
        this.allList = 0;
        this.isAlllist = [];
        if (res.ret === 0) {
          console.log('----受到通报批评列表：', res);
          this.accidentScore = "-" + (res.data.deduction / 100).toFixed(2);
          this.surplusScore = (res.data.score / 100).toFixed(2);
          this.allScore = (res.data.sumScore / 100).toFixed(1);

          this.accidentList = res.data.voe1 ?? [];

          this.meetList = res.data.voe2;

          this.abarbeitungList = res.data.voe3;

          this.isAlllist.push(...res.data.voe1, ...res.data.voe2, ...res.data.voe3);
          this.showList = this.accidentList.concat(res.data.voe2).concat(res.data.voe3).length > 0 ? true : false;
          if (this.accidentListAuth === 'E1') {
            this.allList += res.data.voe1 ? res.data.voe1.length : 0;
          }
          if (this.meetListAuth === 'E2') {
            this.allList += res.data.voe2 ? res.data.voe2.length : 0;
          }
          if (this.abarbeitungListAuth === 'E3') {
            this.allList += res.data.voe3 ? res.data.voe3.length : 0;
          }

        }
      });
    },
    // 新增
    addSituation() {
      const { quarter, area, year } = this.$route.query;
      this.$router.push({
        path: "/appraise/notificationAdd",
        query: {
          //传值权限到 新增页面
          accidentListAuth: this.accidentListAuth,
          meetListAuth: this.meetListAuth,
          abarbeitungListAuth: this.abarbeitungListAuth,
          quarter,
          area,
          year,
        },
      });
    },
    // 查看详情
    goDetail(type) {
      const { area, year, quarter,areaName,quarterName } = this.$route.query;
      // this.$router.push(`/appraise/deductDetailNotifi?id=${item.id}`);
      // this.$router.push({
      //   path: "/appraise/deductDetailNotifi",
      //   query: {
      //     id: item.id,
      //     area,
      //     year,
      //     quarter,
      //     userAuthoirese: this.userAuthoirese,
      //     updateAuth: this.updateAuth,
      //     deleteAuth: this.deleteAuth,
      //     accidentListAuth: this.accidentListAuth,
      //     meetListAuth: this.meetListAuth,
      //     abarbeitungListAuth: this.abarbeitungListAuth
      //   },
      // });
      this.setECategoryList(type == 'E2' ? this.meetList : this.abarbeitungList)
      this.$router.push({
        path: "/appraise/notificationDetail",
        query: {
          area,
          year,
          quarter,
          areaName,
          quarterName,
          type,
          deduction: type == 'E2' ? this.totalDeduction(this.meetList) : this.totalDeduction(this.abarbeitungList)
        },
      })
    },
    totalDeduction(list) {
      let sum = list.reduce((acc, cur) => {
        if(cur.audited){
          return acc + cur.deduction;
        }else{
          return acc;
        }
        
      }, 0);
      sum = (sum/100).toFixed(1);
      if(sum>=2.0){
        sum = 2.0;
      }
      return sum;
    },
  },
};
</script>

<style scoped lang="less">
.deduct_list {
  height: 100%;
  background-color: #fbfbfb;
}

.head {
  display: flex;
  justify-content: space-between;
  padding: 0 12px;
  width: 100%;
  background-color: #fff;
}

.head_left {
  padding-top: 20px;
  width: 276px;
  color: #333;
  font-size: 20px;
  line-height: 28px;
  font-weight: bold;
}

.head_right {
  text-align: right;

  .score {
    padding: 22px 0 8px;
    color: #ff4d4d;
    font-size: 22px;
    line-height: 22px;
    font-weight: 500;
  }

  .noScore {
    padding: 22px 0 8px;
    color: #999;
    font-size: 22px;
    line-height: 22px;
    font-weight: 500;
  }

  .percent {
    font-size: 14px;
    font-weight: 500;
    color: #999;
  }
}

.save_list {
  padding: 0 12px;

  .list_top {
    display: flex;
    justify-content: space-between;
  }

  .add_btn {
    margin: 24px 0 12px;
    width: 70px;
    height: 30px;

    span {
      line-height: 30px;
    }

    .plus {
      padding-right: 3px;
      line-height: 28px;
      vertical-align: top;
    }
  }

  .total {
    margin: 32px 0 20px;
    font-size: 14px;
    font-weight: 400;
    color: #333;

    span {
      color: #ff8c19;
      font-weight: 500;
    }
  }

  .record_list {
    margin-bottom: 12px;
    background: #fff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
    border-radius: 3px;
  }

  .items {
    margin-bottom: 16px;
  }

  .deduct_score {
    font-size: 12px;
    font-weight: 500;
    color: #ff4d4d;
  }

  .record_item {
    padding: 16px;
    border-bottom: 1px solid #eee;

    .status {
      font-size: 12px;
      color: #ff8c19;
    }

    .deduct_item {
      margin-bottom: 16px;
    }

    .record_title {
      display: flex;
      justify-content: space-between;
      margin-bottom: 16px;
      color: #333;
      font-size: 14px;
      font-weight: bold;
    }

    &:last-child {
      border: 0;
    }

    .reason {
      margin-bottom: 8px;
      font-size: 12px;
      color: #666;
    }

    .deal_cont {
      display: flex;
      justify-content: space-between;

      .left_cont {
        width: 265px;
        padding: 3px 0 0 0;
        margin-top: -3px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

    .see_more {
      padding-top: 8px;
      font-size: 12px;
      color: #36b374;

      img {
        margin-left: 2px;
        display: inline-block;
        width: 12px;
        height: 12px;
        vertical-align: top;
      }
    }
  }
}

.no_data {
  .no_data_img {
    padding: 72px 0 20px;

    img {
      margin: 0 auto;
      width: 74px;
      height: 62px;
    }
  }

  .no_data_tip {
    line-height: 22px;
    font-size: 14px;
    color: #999;
    text-align: center;
  }

  .add_btn_box {
    padding: 32px 0;
    background-color: transparent;
    text-align: center;

    .add_btns {
      width: 70px;
      height: 30px;
    }

    span {
      line-height: 30px;
    }

    .plus {
      padding-right: 3px;
      line-height: 28px;
      vertical-align: top;
    }
  }
}
</style>